document.addEventListener("DOMContentLoaded", () => {
  console.log("Custom modal script loaded");

  const detailButtons = document.querySelectorAll('[id^="details-"]');

  if (detailButtons.length === 0) {
    console.warn("No detail buttons found with id^=details-");
  }

  detailButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();

      const variantId = button.id.split("-")[1];
      console.log("Clicked details for variant:", variantId);

      const modal = document.getElementById("ModalDetails-" + variantId);

      if (modal && typeof modal.show === "function") {
        console.log("Opening modal", modal.id);
        modal.show(button);
      } else {
        console.error("Modal not found or modal.show() missing for variant:", variantId);
      }
    });
  });
});
